export class ApplicationUrls {
    public static Home: string = "/";
    public static ContactUs: string = "/contact";
    public static Legal: string = "/legal";
}